import React, { useState } from 'react';
import { useAppSelector } from '../dal/store';
import { saveStats } from '../dal/data-service';

const Copy = () => {

    const shareUrl = useAppSelector(store => store.root.shareUrl);
    const userWidget = useAppSelector(store => store.root.userWidget);

    const [ okText, setOkText] = useState('');

    const onCopyClick = async () => {
        await navigator.clipboard.writeText(shareUrl);
        setOkText('Copied!');

        window.setTimeout(() => {
            setOkText('');
        }, 2000);

        await saveStats('purl', userWidget?.shortURL || '');
    };

    return (
        <div className="mb-4">
            <p className="mb-2">OR PASTE YOUR LINK ANYWHERE</p>
            <p className="flex items-center justify-center">
                <input
                    type="text"
                    value={ shareUrl }
                    className="border rounded px-4 py-2 mr-1 ml-6 outline-none"
                    disabled={ true }
                    style={{
                        width: '295px',
                    }} />

                <button type="button" onClick={ onCopyClick } className="relative">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"
                         fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path
                            d="M8 8m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"></path>
                        <path d="M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"></path>
                    </svg>

                    { okText && <p className="text-sm text-green absolute left-0">{ okText }</p> }
                </button>
            </p>


        </div>
    )
};

export default Copy;